import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createElement } from 'react';
import { ksdpAppsecReadPermission } from '@internal/ksdp-permissions-common';
import { guardKsdpPage } from '@internal/ksdp-permissions-react';
import { Navigate } from 'react-router-dom';
import { BusinessApplicationsPage } from './components/BusinessApplicationsPage';
import { BusinessApplicationDetailsPage } from './components/BusinessApplicationDetailsPage';
import { CustomSecurityIcon } from './icons/SecurityIcon';

const applicationSecurityDefaultPage = PageBlueprint.make({
  name: 'application-security-default',
  params: {
    path: '/',
    title: 'Application Security View',
    icon: createElement(CustomSecurityIcon),
    loader: async () =>
      createElement(Navigate, { to: '/business-applications', replace: true }),
  },
});

const businessApplicationsListPage = PageBlueprint.make({
  name: 'business-applications-list',
  params: {
    path: '/business-applications',
    title: 'Application Security View',
    icon: createElement(CustomSecurityIcon),
    loader: async () =>
      guardKsdpPage(
        ksdpAppsecReadPermission,
        createElement(BusinessApplicationsPage),
      ),
  },
});

const businessApplicationsDetailsPage = PageBlueprint.make({
  name: 'business-applications-details',
  params: {
    path: '/business-applications/:ban',
    title: 'Application Details',
    icon: createElement(CustomSecurityIcon),
    loader: async () =>
      guardKsdpPage(
        ksdpAppsecReadPermission,
        createElement(BusinessApplicationDetailsPage),
      ),
  },
});

export const businessApplicationsPlugin = createFrontendPlugin({
  pluginId: 'business-applications',
  extensions: [
    applicationSecurityDefaultPage,
    businessApplicationsListPage,
    businessApplicationsDetailsPage,
  ],
});
